{
	"main": {
		"title": "Jadralni leti",
		"subtitle1": "PODATKI JADRALNEGA LETALA",
		"subtitle2": "PODATKI VLEČNEGA LETALA",
		"subtitle3": "SPLOŠNI PODATKI",
		"nazaj": "Nazaj"
	},
	"nav": {
		"vnos": "Vnos",
		"zapisi": "Zapisi"
	},
	"labels": {
		"pilotJ": "Izberi pilota jadralnega letala:",
		"instruktor": "Izberi inštruktorja jadralnega letala:",
		"registracijaJ": "Izberi reg. jadralnega letala :",
		"namenJ": "Izberi namen :",
		"nalogaJ": "Izberi nalogo jadralnega leta:",
		"pilotM": "Izberi pilota vlečnega letala:",
		"registracijaM": "Izberi reg. letala za vleko :",
		"vzlet": "Izberi vzlet :",
		"pristanek": "Izberi pristanek :",
		"poletanje": "Poletanje :",
		"odklop": "Odklop :",
		"nezakljucen": "Nezaključen let?",
		"pristanekJ": "Pristanek jadralnega letala:",
		"pristanekM": "Pristanek vlečnega letala:",
		"opomba": "Opomba",
		"novIcao": "vnesi ICAO letališča",
		"dodajLetalisce": "Dodajanje letališča",
		"opozorilo": "Vleko se vpisuje da se v polje \"Poletanje\" vpiše čas, ko se letalo premakne z namenom vzleta z zapeto vlečno vrvjo.\nV polje \"Pristanek vlečnega letala\" pa ko se letalo po pristanku popolnoma ustavi."
	},
	"buttons": {
		"brisiIzbiro": "Pobriši izbiro",
		"vnesiZapis": "Vnesi zapis",
		"dodajLetalisce": "Dodaj"
	},
	"obvestila": {
		"brisiSredstvo": "Ali res želiš izbrisati sredstvo?",
		"vnosUspesen": "vnos uspešen. Ustrezno uredite jadralni dnevnik za ta zapis.",
		"vnosLetaliscaUspesen": "vnos uspešen.",
		"vnosNeuspesen": "Napaka pri pridobivanju podatkov.",
		"nepricakovanaNapaka": "Prišlo je do nepričakovane napake",
		"napakaBranja": "Napaka pri branju podatkov.",
		"napakaBranjaNezakljuceni": "Napaka pri branju podatkov (nezaključeni leti).",
		"napakaBranjaCasVleke": "Napaka pri branju podatkov (čas vleke).",
		"poslano": "Sporočilo poslano",
		"niPoslano": "Sporočilo ni bilo poslano",
		"zapisPrihodnost": "Zapis ima izbran datum v prihodnosti, POPRAVI izbran datum!",
		"zapisCasPrihodnost": "Zapis ima pri enem ali več zapisih uro v prihodnosti, preglej čase!",
		"zapisCasNapaka": "Časi zapisov so nepravilni! Preveri čase še enkrat!",
		"zapisDodan": "Zapis uspešno dodan! Ustrezno uredite jadralni dnevnik za ta zapis.",
		"zapisNapaka": "Napaka pri vnosu podatkov",
		"zapisNapakaMotorno": "Napaka pri vnosu podatkov (motorno vleka).",
		"napakaInputa": "Napaka pri vnosu. Polja označena z rdečo so obvezna! Preglej če imaš izpolnjena vsa polja!",
		"napakaDodajanjaLetalisca": "Prišlo je do napake pri vnosu letališča",
		"letalisceNiNajdeno": "ICAO koda letališča ni najdena v bazi podatkov"
	}
}